var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"roundup-container",class:[
		(_vm.isOnboarding || _vm.navProminent) && 'prominent',
		!_vm.showNavHeader && 'no-header'
	],style:({ 'padding-top': _vm.paddingTop })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }